import { store } from 'store/store';

const doubleCurlyRegex = /{{(.+?)}}/g;

const enum FIELD_PROPERTY {
	TITLE = 'title',
	SUBTITLE = 'subtitle',
	LABEL = 'label',
	CONTENT = 'content',
	TEXT = 'text',
	REGULAR_PRICE_LABEL = 'regularPriceLabel',
	YOUR_PRICE_LABEL = 'yourPriceLabel',
	ADDITIONAL_PRICE_DETAILS = 'additionalPriceDetails',
	TOTAL_PRICE = 'totalPrice',
}

export const replacePlaceholders = (field: FieldsBlock) => {
	switch (field?.contentType) {
		case 'CalculatorStepBlock':
		case 'RadioCardFieldBlock':
			replacePlaceholderByType(field, FIELD_PROPERTY.TITLE);
			break;
		case 'CheckboxFieldBlock':
			replacePlaceholderByType(field, FIELD_PROPERTY.LABEL);
			break;
		case 'TeaserCardBlock':
		case 'UserConsentBlock':
			replacePlaceholderByType(field, FIELD_PROPERTY.CONTENT);
			break;
		case 'ParagraphBlock':
			replacePlaceholderByType(field, FIELD_PROPERTY.TEXT);
			break;
		default:
			return;
	}
};

export const replacePlaceholdersModal = (field: FieldsBlock) => {
	replacePlaceholderByType(field, FIELD_PROPERTY.CONTENT);
	replacePlaceholderByType(field, FIELD_PROPERTY.TITLE);
	replacePlaceholderByType(field, FIELD_PROPERTY.SUBTITLE);
};

export const replacePlaceholdersSummaryComponent = (field: SummaryProductDetailsBlock) => {
	replacePlaceholderByType(field, FIELD_PROPERTY.REGULAR_PRICE_LABEL);
	replacePlaceholderByType(field, FIELD_PROPERTY.YOUR_PRICE_LABEL);
	replacePlaceholderByType(field, FIELD_PROPERTY.ADDITIONAL_PRICE_DETAILS);
};

export const replacePlaceholdersSummaryTotalPriceComponent = (field: SummaryTotalPriceDetailsBlock) => {
	replacePlaceholderByType(field, FIELD_PROPERTY.TOTAL_PRICE);
};

export const getReplacedValue = (value: string) => {
	const matches = value?.match(doubleCurlyRegex);
	if (matches?.length > 0) {
		return replacePlaceholder(value, matches);
	}
	return value;
};

const replacePlaceholderByType = (field: FieldsBlock | SummaryProductDetailsBlock, propertyType: FIELD_PROPERTY) => {
	if (field?.[propertyType]) {
		if (Array.isArray(field[propertyType])) {
			field[propertyType] = field[propertyType].map((item) => {
				const matches = item.match(doubleCurlyRegex);
				return matches?.length > 0 ? replacePlaceholder(item, matches) : item;
			});
		} else {
			const matches = field[propertyType].match(doubleCurlyRegex);
			if (matches?.length > 0) {
				field[propertyType] = replacePlaceholder(field[propertyType], matches);
			}
		}
	}
};

const replacePlaceholder = (value: string, matches: string[]) => {
	let result = value;
	let regMatch: RegExp;
	let replacement: string;
	const definitions = store.getState().placeholderDefinitions.definitions;
	const form = store.getState().calculatorForm;

	matches.forEach((match) => {
		regMatch = new RegExp(match, 'gi');
		replacement = getFormValue(match, form);
		if (replacement === '') {
			// check if value is present in definitions
			replacement = getPlaceholderReplacement(match, definitions, form);
		}
		if (!isDevelop() || !result.includes('!NA{{')) {
			result = result.replace(regMatch, replacement).trim();
		}
	});
	return result;
};

const getFormValue = (placeholder: string, form) => {
	const formId = placeholder.replace(/{{|}}/g, '').toUpperCase();
	const value = form[formId]?.data?.label ?? form[formId]?.data?.value;
	return value ?? '';
};

const getPlaceholderReplacement = (placeholder: string, definitions, form) => {
	const definitionMatch = definitions[placeholder.toUpperCase()];
	let value = undefined;
	if (definitionMatch) {
		value = form[definitionMatch]?.data?.label ?? form[definitionMatch]?.data?.value;
	}
	if (value) {
		return value;
	} else if (isDevelop()) {
		// for debug in test environment
		return `!NA${placeholder}`;
	}
	// remove unknown placeholder from text
	return '';
};

const isDevelop = () => {
	return location.href.startsWith('https://localhost') || location.href.startsWith('https://sit-');
};
